import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "point",
  "use": "point-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"point\"><g transform=\"translate(5.382 -1022.62)\"><ellipse cx=\"6.227\" cy=\"1034.8\" rx=\"2.532\" ry=\"2.558\" style=\"fill:currentColor;stroke:currentColor;stroke-width:.45078;stroke-linejoin:round;stroke-dashoffset:5.06459999\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol